import { apiDelete, apiGet, apiPut } from "../../../utils/apiRequests";
import { 
  CREATE_DRAW_LOADING, 
  CREATE_DRAW_SUCCESS, 
  CREATE_DRAW_ERROR,
  SEND_DRAWS_LOADING,
  SEND_DRAWS_ERROR,
  SEND_DRAWS_SUCCESS
 } from "../../../constant/actionTypes";
import ApiEndpoints from "../../../utils/ApiEndpoints";

export const createDraw = (data, id, doneCB) => (dispatch) => {
  dispatch({ type: CREATE_DRAW_LOADING });
  apiPut(
    `${ApiEndpoints.tournament.base}${ApiEndpoints.tournament.poty}${ApiEndpoints.tournament.addDraws}${id}`,
    data,
    (response) => {
      // console.log("create draw  response ==============> ", response);
      if (response.error === true) {
        dispatch({ type: CREATE_DRAW_ERROR, response: response.message });
        if(doneCB) doneCB()
      } else {
        dispatch({ type: CREATE_DRAW_SUCCESS, response: response });
        if(doneCB) doneCB()
      }
    },

    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: CREATE_DRAW_ERROR, response: error });
      if(doneCB) doneCB()
    }
  );
}

export const sendDraws = (id, doneCB, errorCB = null) => dispatch => {
  dispatch({ type: SEND_DRAWS_LOADING})
  apiPut(
    `${ApiEndpoints.tournament.base}${ApiEndpoints.tournament.poty}${ApiEndpoints.tournament.sendDraws}${id}`,
    (response) => {
      // console.log("send draws  response ==============> ", response);
      if (response.error === true) {
        if(errorCB) errorCB()
        dispatch({ type: SEND_DRAWS_ERROR, response: response.message });
      } else {
        dispatch({ type: SEND_DRAWS_SUCCESS, response: response });
        if(doneCB) doneCB()
      }
    },

    (error) => {
      // console.log("error ===>>>>", error);
      if(errorCB) errorCB(error)
      dispatch({ type: SEND_DRAWS_ERROR, response: error });
    }
  )

}